import { useEffect, useState } from "react";
import { useDealContext } from "../../deal/context";
import ProjectHttpClient from "../../../core/infrastructure/clients/v1/ProjectHttpClient";
import { useAuth0 } from "@auth0/auth0-react";
import { CompanyTitle } from "../components/CompanyTitle";
import { Box } from "@mui/material";
import { ExecTab } from "../styles/AdvisorStyles";
import { ExecTabs } from "../styles/AdvisorStyles";
import { UpcomingList } from "../components/meetings/UpcomingList";
import { CompletedList } from "../components/meetings/CompletedList";
import { CustomersList } from "../components/meetings/CustomersList";
import { OpportunitiesList } from "../components/meetings/OpportunitiesList";
import { useNavigate, useParams } from "react-router-dom";
import { IProject, IAdvisor, IMeeting, IScheduler, SchedulerType } from "../../../types";
import { useAdvisors } from "../../advisor/context/AdvisorsContext";
import ClientProvider from "../../../modules/ClientProvider";
import { CombinedList } from "../components/meetings/CombinedList";
import { SingleList } from "../components/meetings/SingleList";

const meetingStates = ["intro", "demo", "trial"];

export const CompanyMeetings = () => {

    const { advisors, loading, fetchAdvisors } = useAdvisors();
    const { meetingState, meetingUuid } = useParams();
    const { getAccessTokenSilently } = useAuth0();
    const [value, setValue] = useState(meetingStates.indexOf(meetingState && meetingStates.includes(meetingState) ? meetingState : "intro"));
    const { dealContext } = useDealContext();
    const project = dealContext.project as IProject;
    const viewerRole = dealContext.role;
    const projectHttpClient = new ProjectHttpClient();
    const navigate = useNavigate();
    const schedulerClient = ClientProvider.provideSchedulerClient();
    const [ schedulers, setSchedulers] = useState<IScheduler[] | null>(null);
    const [ introMeetings, setIntroMeetings] = useState<IMeeting[]>([]);
    const [ demoMeetings, setDemoMeetings] = useState<IMeeting[]>([]);
    const [ trialMeetings, setTrialMeetings] = useState<IMeeting[]>([]);

    const fetchSchedulerData = async () => {
        const accessToken = await getAccessTokenSilently();
        const { data, error } = await schedulerClient.getSchedulers(project.tag, accessToken);
        if (error) {
            console.error('Error fetching demo scheduler data:', error);
        } else {
            setSchedulers(data.schedulers);
        }
    };

    const fetchMeetings = async () => {
        const accessToken = await getAccessTokenSilently();
        const { data, error } = await projectHttpClient.getMeetings(project.id, accessToken);
        if (data) {
            setIntroMeetings(data.meetings.filter((meeting: IMeeting) => 
                meeting.scheduler?.type === "intro"
            ));
            setDemoMeetings(data.meetings.filter((meeting: IMeeting) => 
                meeting.scheduler?.type === "demo"
            ));
            setTrialMeetings(data.meetings.filter((meeting: IMeeting) => 
                meeting.scheduler?.type === "trial"
            ));
        }
    }

    const loadMeetings = async () => {
        await fetchMeetings();
    }

    const loadData = async () => {
        await fetchAdvisors(project.id);
        await loadMeetings();
    }

    useEffect(() => {
        loadMeetings();
        fetchSchedulerData();

        return () => {
            setSchedulers(null);
            setIntroMeetings([]);
            setDemoMeetings([]);
            setTrialMeetings([]);
        };
    }, []);


    const handleTabSwitch = (event: any, newValue: any) => {
        setValue(newValue);
        navigate(`/c/meetings/${meetingStates[newValue]}`);
    }

    return (
        <Box>
            <CompanyTitle viewerRole={viewerRole} project={project} section="Meetings" subheading="Schedule and prep for meetings with advisors, and track them through to opportunities and customers." />
            <Box>
                <ExecTabs variant="fullWidth" value={value} onChange={handleTabSwitch}>
                    <ExecTab label={<div><span className="count">{introMeetings.length}</span> {project.effective_scheduler_properties?.intro?.name ?? "Intro"}</div>}></ExecTab>
                    <ExecTab label={<div><span className="count">{demoMeetings.length}</span> {project.effective_scheduler_properties?.demo?.name ?? "Demo"}</div>}></ExecTab>
                    <ExecTab label={<div><span className="count">{trialMeetings.length}</span> {project.effective_scheduler_properties?.trial?.name ?? "Trial"}</div>}></ExecTab>
                </ExecTabs>
                {value === 0 && <Box>
                    <SingleList project={project} reloadData={loadData} meetings={introMeetings} type={SchedulerType.INTRO} />
                </Box>}
                {value === 1 && <Box>
                    <SingleList project={project} reloadData={loadData} meetings={demoMeetings} type={SchedulerType.DEMO} />
                </Box>}
                {value === 2 && <Box>
                    <SingleList project={project} reloadData={loadData} meetings={trialMeetings} type={SchedulerType.TRIAL} />
                </Box>}
            </Box>
        </Box>
    )
}